import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import CustomerListPageUI from './CustomerListPageUI.js'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils';

class CustomerListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      customerList: null,
      filteredCustomerList: null,
      // filters
      searchFilter: '',
      //
      successMsg: null,
      errorList: null,
      createMode: false,
      updateMode: false,
      deleteMode: false,
      submitted: false,
      selectedCount: 0,
      //
      customerName: '',
      customerNameError: null,
      // contact attributes
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      // phoneNumber attributes
      phoneNumber: null,
      phoneNumberError: null,
      // email attributes
      email: '',
      emailError: null,
      //
      selectedCustomerId: null
    }
  }

  render() {
    return (
      <CustomerListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        customerList={this.state.customerList}
        filteredCustomerList={this.state.filteredCustomerList}
        // filters
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        // form
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => { this.setState({ errorList: errorList }) }}
        // modes
        selectedCount={this.state.selectedCount}
        createMode={this.state.createMode}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        submitted={this.state.submitted}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onCreateClick={this.onCreateClick}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        onConfirmCreateClick={this.onConfirmCreateClick}
        onConfirmUpdateClick={this.onConfirmUpdateClick}
        onConfirmDeleteClick={this.onConfirmDeleteClick}
        onCancelClick={this.onCancelClick}
        // 
        customerName={this.state.customerName}
        onCustomerNameChange={(event) => { this.setStateValue('customerName', event.target.value) }}
        customerNameError={this.state.customerNameError}
        setCustomerNameError={(error) => { this.setStateValue('customerNameError', error) }}
        // contact attributes and methods
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        onFirstNameChange={(event) => { this.setStateValue('firstName', event.target.value) }}
        onLastNameChange={(event) => { this.setStateValue('lastName', event.target.value) }}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        setFirstNameError={(error) => { this.setStateValue('firstNameError', error) }}
        setLastNameError={(error) => { this.setStateValue('lastNameError', error) }}
        // phoneNumber attributes and methods
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(value) => { this.setStateValue('phoneNumber', value) }}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => { this.setStateValue('phoneNumberError', error) }}
        // email attributes and methods
        email={this.state.email}
        onEmailChange={(event) => { this.setStateValue('email', event.target.value) }}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setStateValue('emailError', error) }}
      />

    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCustomers(context)
    Modal.setAppElement('body')
  }

  getCustomers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/customers`,
      cacheKey: CacheKeys.Customers(context.session.accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    response.customerList && response.customerList.forEach(customer => {
      customer.selected = false
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.CustomersFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.customerList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
    // this.setState({errorList: response.errorList, vendorList : response.vendorList})
  }

  applyFilters(customerList, searchFilter, errorList) {
    let filteredList = customerList
    if (searchFilter)
      filteredList = filteredList.filter(customer => customer.customerName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    // remove checked flag from rows that are hidden
    let selectedSet = new Set()
    customerList.filter(customer => customer.selected).forEach(customer => { selectedSet.add(customer.customerId) })
    customerList.forEach(customer => { customer.selected = false })
    filteredList.filter(customer => selectedSet.has(customer.customerId)).forEach(customer => { customer.selected = true })

    this.setState({
      customerList: customerList,
      filteredCustomerList: filteredList,
      searchFilter: searchFilter,
      selectedCount: filteredList.filter(customer => customer.selected).length,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.CustomersFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Customers(context.session.accountId))
    CacheManager.removeObject(CacheKeys.Messages('pg_acc_cust', context.locale))
    this.setState({
      errorList: null,
      customerList: null,
      customerName: '',
      customerNameError: null,
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      phoneNumber: null,
      phoneNumberError: null,
      email: '',
      emailError: null,
      selectedCustomerId: null
    })
    this.getCustomers(context);
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.customerList, searchFilter)
  }

  onRowClick = event => {
    let customerId = event.currentTarget.getAttribute('data-row-id')
    let customerList = this.state.customerList
    customerList
      .filter(customer => customer.customerId === customerId)
      .forEach(customer => {
        customer.selected = !Boolean(customer.selected)
      })

    this.setState({ customerList: customerList })
    this.applyFilters(customerList, this.state.searchFilter)
  }

  onCreateClick = () => {
    this.setState({
      createMode: true
    });
  }

  onConfirmCreateClick = () => {
    this.setStateValue('submitted', true);

    RestApiUtils.post(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/customers`,
      this.onSubmitCallback, {
      customerName: this.state.customerName,
      contactFirstName: this.state.firstName,
      contactLastName: this.state.lastName,
      contactPhone: this.state.phoneNumber,
      contactEmail: this.state.email
    });
  }

  onSubmitCallback = () => {
    this.setStateValue('submitted', false);
    this.onCancelClick();
    this.onRefreshClick();
  }

  onUpdateClick = () => {
    this.getCustomerDetailsAndSetStateForUpdate();
    this.setState({
      updateMode: true
    });
  }

  getCustomerDetailsAndSetStateForUpdate = () => {
    let selectedCustomerDetails = this.state.customerList.find((customer) => (customer.selected));
    this.setState({
      selectedCustomerId: selectedCustomerDetails.customerId,
      customerName: selectedCustomerDetails.customerName,
      firstName: selectedCustomerDetails.contactFirstName,
      lastName: selectedCustomerDetails.contactLastName,
      phoneNumber: selectedCustomerDetails.contactPhone,
      email: selectedCustomerDetails.contactEmail
    });
  }

  onConfirmUpdateClick = () => {
    this.setStateValue('submitted', true);

    RestApiUtils.put(this.props.context,
      `/api/customers/${this.state.selectedCustomerId}`,
      this.onUpdateSubmitCallback, {
      customerName: this.state.customerName,
      contactFirstName: this.state.firstName,
      contactLastName: this.state.lastName,
      contactPhone: this.state.phoneNumber,
      contactEmail: this.state.email
    });
  }

  onUpdateSubmitCallback = () => {
    this.setStateValue('submitted', false);
    this.onCancelClick();
    this.onRefreshClick();
  }

  onCancelClick = () => {
    this.setState({
      createMode: false,
      updateMode: false
    });
  }

  setStateValue = (fieldName, value) => {
    this.setState({
      [fieldName]: value
    });
  }
}

export default CustomerListPageSF
